import { AxiosInstance } from "api/axiosInstance";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import {
  CreateFirmwarePackageRequest,
  CreateFirmwarePackageResponse,
  FirmwareAliveStatusRequest,
  FirmwareAliveStatusResponse,
  FirmwarePackageDeleteResponse,
  FirmwarePackageDownloadUrlResponse,
  FirmwarePackageListResponse,
  FirmwarePackageUpdateResponse,
  FirmwarePackageUploadStatusResponse,
  FirmwareUpdateInfoResponse,
  FirmwareUpgradeRequest,
  FirmwareUpgradeResponse,
  UpdateFirmwarePackageRequest,
  UploadStatusFirmwareRequest,
} from "api/interfaces/settingsInterface.interface";
import axios, { AxiosResponse } from "axios";
import qs from "qs";
const API_PATH = "/setting/firmwarePackage";

export const getFirmwareDownloadUrl = async (
  id: string
): Promise<FirmwarePackageDownloadUrlResponse> => {
  try {
    const { data }: AxiosResponse<FirmwarePackageDownloadUrlResponse> =
      await AxiosInstance.get(`${API_PATH}/downloadUrl/${id}`);
    return data;
  } catch (e) {
    throw e;
  }
};

export const getFirmwareList = async ({
  payload,
}: {
  payload: BasePagination;
}): Promise<FirmwarePackageListResponse> => {
  try {
    const { data }: AxiosResponse<FirmwarePackageListResponse> =
      await AxiosInstance.get(`${API_PATH}/list?${qs.stringify(payload)}`);
    return data;
  } catch (e) {
    throw e;
  }
};

export const getFirmwareUpdateInfo = async (
  recorderId: string
): Promise<FirmwareUpdateInfoResponse> => {
  try {
    const { data }: AxiosResponse<FirmwareUpdateInfoResponse> =
      await AxiosInstance.get(`${API_PATH}/updateInfo/${recorderId}`);
    return data;
  } catch (e) {
    throw e;
  }
};

export const postFirmwarePackage = async (
  payload: CreateFirmwarePackageRequest
): Promise<CreateFirmwarePackageResponse> => {
  try {
    const { data }: AxiosResponse<CreateFirmwarePackageResponse> =
      await AxiosInstance.post(`${API_PATH}/create`, payload);
    return data;
  } catch (e) {
    throw e;
  }
};
export const postFirmwareUploadStatus = async ({
  id,
  payload,
}: {
  id: string;
  payload?: UploadStatusFirmwareRequest;
}): Promise<FirmwarePackageUploadStatusResponse> => {
  try {
    const { data }: AxiosResponse<FirmwarePackageUploadStatusResponse> =
      await AxiosInstance.post(`${API_PATH}/uploadStatus/${id}`, payload ?? {});
    return data;
  } catch (e) {
    throw e;
  }
};

export const postFirmwareAliveStatus = async ({
  recorderId,
  retryCount,
}: FirmwareAliveStatusRequest): Promise<FirmwareAliveStatusResponse> => {
  try {
    const { data }: AxiosResponse<FirmwareAliveStatusResponse> =
      await AxiosInstance.post(`${API_PATH}/checkRecorderAlive/${recorderId}`, {
        retryCount,
      });
    return data;
  } catch (e) {
    throw e;
  }
};

export const putFirmwareUpload = async ({
  presignedUrl,
  file,
}: {
  presignedUrl: string;
  file: File;
}): Promise<void> => {
  try {
    const res: AxiosResponse<void> = await axios.put(presignedUrl, file);
    return res.data;
  } catch (e) {
    throw e;
  }
};
export const putFirmwarePackage = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateFirmwarePackageRequest;
}): Promise<FirmwarePackageUpdateResponse> => {
  try {
    const { data }: AxiosResponse<FirmwarePackageUpdateResponse> =
      await AxiosInstance.put(`${API_PATH}/update/${id}`, payload);
    return data;
  } catch (e) {
    throw e;
  }
};

export const putFirmwareUpgrade = async ({
  recorderId,
  payload,
}: {
  recorderId: string;
  payload: FirmwareUpgradeRequest;
}): Promise<FirmwareUpgradeResponse> => {
  try {
    const { data }: AxiosResponse<FirmwareUpgradeResponse> =
      await AxiosInstance.put(`${API_PATH}/upgrade/${recorderId}`, payload);
    return data;
  } catch (e) {
    throw e;
  }
};

export const deleteFirmwarePackage = async (
  id: string
): Promise<FirmwarePackageDeleteResponse> => {
  try {
    const { data }: AxiosResponse<FirmwarePackageDeleteResponse> =
      await AxiosInstance.delete(`${API_PATH}/delete/${id}`);
    return data;
  } catch (e) {
    throw e;
  }
};
